'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  city: '广州',
  lon: 113.287047,
  lat: 23.17691
}, {
  city: '深圳',
  lon: 114.045941,
  lat: 22.626807
}, {
  city: '香港',
  lon: 114.156,
  lat: 22.373
}, {
  city: '江门',
  lon: 112.965032,
  lat: 22.569499
}, {
  city: '珠海',
  lon: 113.515268,
  lat: 22.398016
}, {
  city: '潮州',
  lon: 116.526471,
  lat: 23.902035
}, {
  city: '汕尾',
  lon: 115.346306,
  lat: 22.988848
}, {
  city: '澳门',
  lon: 113.5381,
  lat: 22.1951
}, {
  city: '阳江',
  lon: 111.957711,
  lat: 21.849029
}, {
  city: '茂名',
  lon: 110.881743,
  lat: 21.671237
}, {
  city: '湛江',
  lon: 110.276773,
  lat: 21.199683
}, {
  city: '海口',
  lon: 110.344816,
  lat: 20.039286
}, {
  city: '三亚',
  lon: 109.506117,
  lat: 18.255282
}, {
  city: '南宁',
  lon: 108.337114,
  lat: 22.781747
}, {
  city: '北海',
  lon: 109.128304,
  lat: 21.433841
}, {
  city: '福州',
  lon: 119.275,
  lat: 26.0685
}, {
  city: '宁德',
  lon: 119.524,
  lat: 26.6669
}, {
  city: '莆田',
  lon: 119.015,
  lat: 25.4426
}, {
  city: '泉州',
  lon: 118.582,
  lat: 24.9223
}, {
  city: '厦门',
  lon: 118.077,
  lat: 24.4667
}, {
  city: '漳州',
  lon: 117.658,
  lat: 24.5166
}, {
  city: '台北',
  lon: 121.51963,
  lat: 25.040897
}];


//////////////////
// WEBPACK FOOTER
// ./js/util/typhoonCities.conf.js
// module id = 33
// module chunks = 0